import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PostAxios, TokenExpireOnAPIRequest, responseCatchFunc } from "../../Services/RequestService";
import PasswordStrengthMeter from "./PasswordStrengthMeter";
import {
  setMainLoading,
  setPageTitle,
} from "../../Store/reducers/Common";
import { setToastData } from "../../Store/reducers/Toast";
import { useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { logoutUser } from "../../Store/reducers/Users";
const ResetPassword = () => {
  const dispatch = useDispatch();
  const { accessToken, userData } = useSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setPageTitle("Reset Password"));
    return () => {
      dispatch(setMainLoading(false));
    };
  }, []);

  return (
    <>
      <div className="main-form-sec">
        <Formik
          initialValues={{
            email: userData.email,
            user_pass: "",
            new_pass: "",
            confirm_pass: "",
          }}
          validate={(values) => {
            const errors = {};
            let caps = (values.new_pass.match(/[A-Z]/g) || []).length;
            let small = (values.new_pass.match(/[a-z]/g) || []).length;
            let num = (values.new_pass.match(/[0-9]/g) || []).length;
            let specialSymbol = (values.new_pass.match(/\W/g) || []).length;
            let passwordError = [];
            if (caps < 1) {
              passwordError.push("one UPPERCASE letter");
            }
            if (small < 1) {
              passwordError.push("one lowercase letter");
            }
            if (num < 1) {
              passwordError.push("one number");
            }
            if (specialSymbol < 1) {
              passwordError.push("one special symbol: @$! % * ? &");
            }

            if (!values.user_pass) {
              errors.user_pass = "This field is required";
            }
            if (!values.new_pass) {
              errors.new_pass = "This field is required";
            } else if (values.new_pass.length < 8) {
              errors.new_pass = "Password should not be less than 8 characters";
            } else if (passwordError.length > 0) {
              errors.new_pass = "Must include " + passwordError.join(",");
            }
            if (!values.confirm_pass) {
              errors.confirm_pass = "This field is required";
            } else if (values.new_pass !== values.confirm_pass) {
              errors.confirm_pass = "Password does not match";
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            dispatch(setMainLoading(true));
            PostAxios(
              "/web/resetPassword",
              {
                email: values.email,
              },
              accessToken
            )
              .then(function ({ data }) {
                if (data?.code === 401) {
                  TokenExpireOnAPIRequest(dispatch, data)
                } else if (data.code === 200) {
                  dispatch(
                    setToastData({
                      message: `${data.message}`,
                      type: "success",
                      showCloseBtn: true,
                    })
                  );
                  setTimeout(() => {
                    dispatch(logoutUser());
                  }, 2500);
                  navigate(-1);
                } else {
                  dispatch(
                    setToastData({
                      message: `${data.message}`,
                      type: "error",
                      showCloseBtn: true,
                    })
                  );
                }
              })
              .catch(function (error) {
                responseCatchFunc(dispatch, error);
              })
              .finally(() => {
                dispatch(setMainLoading(false));
                setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
            /* and other goodies */
          }) => (
            <Form>
              <div className="form-sec active">

                <div
                  className={`form-field-group w-50`}
                >
                  <div className="w-50">
                    <label>User Email</label>
                  </div>
                  <div className="w-50 input-area">
                    <input
                      type="text"
                      placeholder="Email"
                      name="text"
                      className="form-input"
                      value={values.email}
                      readOnly
                      disabled
                    />
                  </div>
                </div>

                <div
                  className={`form-field-group w-50 ${errors.user_pass && touched.user_pass ? "error-input" : ""
                    }`}
                >
                  <div className="w-50">
                    <label>Old Password</label>
                  </div>
                  <div className="w-50 input-area">
                    <Field type="password" className="form-input" placeholder="Old Password" name='user_pass' />
                    <ErrorMessage component="span" name="user_pass" className="error-label" />
                  </div>
                </div>
                <div
                  className={`new-password-cms form-field-group w-50 ${errors.new_pass && touched.new_pass ? "error-input" : ""
                    }`}
                >
                  <div className="w-50">
                    <label>New Password</label>
                  </div>
                  <div className="w-50 input-area">
                    <div className="mb-3">
                      <Field type="password" className="form-input" placeholder="New Password" name='new_pass' />
                      <ErrorMessage component="span" name="new_pass" className="error-label" />
                    </div>
                    <PasswordStrengthMeter
                      password={values.new_pass}
                    />
                  </div>
                </div>
                <div
                  className={`new-password-cms form-field-group w-50 ${errors.confirm_pass && touched.confirm_pass ? "error-input" : ""
                    }`}
                >
                  <div className="w-50">
                    <label>Confirm Password</label>
                  </div>
                  <div className="w-50 input-area">
                    <Field type="password" className="form-input" placeholder="New Password" name='confirm_pass' />
                    <ErrorMessage component="span" name="confirm_pass" className="error-label" />
                  </div>
                </div>
              </div>
              <div className="btm-right-btn">
                <button className="btn-blue btn" type="submit">
                  Update
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ResetPassword;
